import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faEye, faClose } from "@fortawesome/free-solid-svg-icons"; // Solid icons
import { faHeart as outlineHeart } from "@fortawesome/free-regular-svg-icons"; // Outlined heart
import "./style.scss";
import { useGethomesectionsQuery } from "../../../../services/homeAPI";

import { faHeart as solidHeart } from "@fortawesome/free-solid-svg-icons";
import {
  useAddToCartMutation,
  useAddToWishlistMutation,
  useGetWishlistQuery,
  useRemoveFromWishlistMutation,
} from "../../../../services/AddToCartAPI";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useGetCartCountQuery } from "../../../../services/cartPageAPI";
import { useGetColorThemeQuery } from "../../../../services/commonAPI";
import Loader from "../../fullPageLoader";
import QuickView from "../../quick-view-product";

function BestSellerProducts() {
  const [isWishlisted, setIsWishlisted] = useState({}); // Track wishlist status for each product
  const [showAddToCartMessage, seShowAddToCartMessage] = useState(false);
  const [showWishListMessage, seShowWishListMessage] = useState(false);
  const { data, error, isLoading } = useGethomesectionsQuery();

  const { data: colorthemeData } = useGetColorThemeQuery();

  const navigate = useNavigate();
  const products =
    data?.data?.filter(
      (item) => item.product_source === "best_seller" && item.is_active
    ) || [];

  console.log("best seller products", products);

  const { data: wishlistData } = useGetWishlistQuery(); // Fetch wishlist data
  const [addToCart] = useAddToCartMutation(); // Add to Cart mutation
  const [addToWishlist] = useAddToWishlistMutation(); // Add to Wishlist mutation
  const [removeFromWishlist] = useRemoveFromWishlistMutation(); // RTK Query mutation
  const [isOpenQuickViewModal, setHandleShowQuickViewModal] = useState(false);
  const [quickViewId, setQuickViewId] = useState("");
  const { refetch: refetchCartCountData } = useGetCartCountQuery();

  // Check if products are in the wishlist
  useEffect(() => {
    if (wishlistData?.data && data?.data) {
      const wishlistStatus = {};
      const bestSellerProducts = data.data.filter(
        (item) => item.product_source === "best_seller" && item.is_active
      )[0]?.products;

      if (bestSellerProducts) {
        bestSellerProducts.forEach((product) => {
          wishlistStatus[product.id] = wishlistData.data.some(
            (item) => item.product.id === product.id
          );
        });
        setIsWishlisted(wishlistStatus);
      }
    }
  }, [wishlistData, data]);

  // Function to handle adding a product to the cart
  const handleAddToCart = async (product) => {
    const accessToken = localStorage.getItem("access_token");
    // const cartToken = localStorage.getItem("cartToken");

    const hasVariants = product.variants && product.variants.length > 0;
    console.log("Has Variants:", hasVariants);

    if (hasVariants) {
      navigate(`/product-detail/${product.id}`);
    }
    else {
      const attributeId = product.attributes && product.attributes.length > 0 ? product.attributes[0].id : null;
      const payload = {
        product_id: product.id,
        quantity: 1,
        product_attribute_id: attributeId
      };

      // Add user_id only if the user is logged in
      if (accessToken) {
        payload.user_id = localStorage.getItem("gridMarker");
      }

      try {
        const response = await addToCart(payload).unwrap();

        // If the user is a guest and a cart token is returned, store it in localStorage
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
        }
        if (response) {
          seShowAddToCartMessage(response.message);
        }
        refetchCartCountData();
      } catch (err) {
        console.error("Failed to add product to cart:", err);
        alert("Failed to add product to cart. Please try again.");
      }
    }


  };

  const handleCloseAddCartToast = () => {
    seShowAddToCartMessage(false);
  };

  const handleWishlistToggle = async (e, product) => {
    e.preventDefault(); // Prevent link navigation
    const accessToken = localStorage.getItem("access_token");
    // const attributeId = product.attributes && product.attributes.length > 0 ? product.attributes[0].id : null;
    const payload = {
      product_id: product.id,
      product_attribute_id: null
      // user_id: accessToken ? localStorage.getItem("gridMarker") : null,
    };

    // Add user_id only if the user is logged in
    if (accessToken) {
      payload.user_id = localStorage.getItem("gridMarker");
    }

    try {
      if (isWishlisted[product.id]) {
        // Remove from wishlist
        const response = await removeFromWishlist(payload).unwrap();
        setIsWishlisted((prev) => ({ ...prev, [product.id]: false }));
        seShowWishListMessage(response.message);
        refetchCartCountData();
      } else {
        // Add to wishlist
        const response = await addToWishlist(payload).unwrap();
        refetchCartCountData();
        if (!accessToken && response.guest_cart_token) {
          localStorage.setItem("cartToken", response.guest_cart_token);
        }

        setIsWishlisted((prev) => ({ ...prev, [product.id]: true }));
        seShowWishListMessage(response.message);
      }
    } catch (err) {
      console.error("Failed to update wishlist:", err);
      alert("Failed to update wishlist. Please try again.");
    }
  };

  const handleCloseWishListToast = () => {
    seShowWishListMessage(false);
  };
  const handleShowQuickView = (id) => {
    setHandleShowQuickViewModal(true);
    setQuickViewId(id);
  };

  const handlecloseQuikViewMOdal = () => {
    setHandleShowQuickViewModal(false);
  };
  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;


  return (
    <>
      {products.length > 0 && (
        <section className="best-seller-products" >
          <div className="container">
            {products[0]?.is_small_heading_active === true && (
              <h5
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.text_color_one ||
                    "#a5a5a5",
                }}
                data-aos="fade-up"
              >
                {products[0].small_heading}
              </h5>
            )}
            {products[0]?.is_title_active === true && (
              <h4
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.heading_color || "#000",
                }}
                data-aos="fade-up"
              >
                {products[0].title}
              </h4>
            )}
            {products[0]?.is_description_active === true && (
              <p
                className="sub-text"
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.paragraph_color ||
                    "#767676",
                }}
                data-aos="fade-up"
              >
                {products[0].description}
              </p>
            )}

            {showAddToCartMessage && (
              <div className="row mb-4 justify-content-center">
                <div className="col-md-5 col-sm-12 -col-lg-5">
                  <div className="d-flex toast-message-add-to-cart">
                    <p>{showAddToCartMessage}</p>
                    <Link to="/cart-page">
                      <p className="primary-button-link">View Cart Page</p>
                    </Link>
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={handleCloseAddCartToast}
                      className="toast-close"
                    />
                  </div>
                </div>
              </div>
            )}

            {showWishListMessage && (
              <div className="row mb-4 justify-content-center">
                <div className="col-md-5 col-sm-12 -col-lg-5">
                  <div className="d-flex toast-message-add-to-wishlist">
                    <p>{showWishListMessage}</p>
                    <Link to="/wishlist">
                      <p className="primary-button-link">View Wishlist</p>
                    </Link>
                    <FontAwesomeIcon
                      icon={faClose}
                      onClick={handleCloseWishListToast}
                      className="toast-close"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="best-seller-list mt-5">
              <div className="row justify-content-center">
                {products[0]?.products?.slice(-4).map((product) => (
                  <div key={product.id} className="col-md-3 col-sm-12 col-lg-3">
                    <Link to={`/product-detail/${product.id}`}>
                      <div className="product-img-wrapper" data-aos="fade-up">
                        <div
                          className="product-img"
                        >
                          {product.is_new === 1 ? (
                            <div className="new-tag">New</div>
                          ) : product.is_hot === 1 ? (
                            <div className="hot-tag">Hot</div>
                          ) : product.discount_percentage > 0 ? (
                            <div
                              className="discount-tag"
                              style={{
                                backgroundColor:
                                  colorthemeData?.color_themes?.[0]
                                    ?.primary_color || "#a76d50",
                              }}
                            >
                              {Math.round(product.discount_percentage)}%
                            </div>
                          ) : null}

                          <img
                            src={product?.product_main_image_url_large}
                            alt="product-img"
                            className="img-fluid"
                            loading="lazy"
                          />

                          {/* Hover actions */}
                          <div className="hover-actions product-action-desk">
                            {product?.attributes?.[0]?.stock > 0 && (
                              <p
                                title="Add to Cart"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent link navigation
                                  handleAddToCart(product);
                                }}
                              >
                                <FontAwesomeIcon icon={faCartPlus} />
                              </p>
                            )}
                            <p
                              title={
                                isWishlisted[product.id]
                                  ? "Remove from Wishlist"
                                  : "Add to Wishlist"
                              }
                              onClick={(e) =>
                                handleWishlistToggle(e, product)
                              }
                              className={`wishlist-btn ${isWishlisted[product.id] ? "wishlisted" : ""
                                }`}
                            >
                              <FontAwesomeIcon
                                icon={
                                  isWishlisted[product.id]
                                    ? solidHeart
                                    : outlineHeart
                                }
                                style={{
                                  color: isWishlisted[product.id]
                                    ? "#ff0000"
                                    : "inherit",
                                }}
                              />
                            </p>
                            <Link
                              onClick={() => handleShowQuickView(product.id)}
                            >
                              <p>
                                {" "}
                                <FontAwesomeIcon icon={faEye} />
                              </p>
                            </Link>
                          </div>
                          {/* ---------- */}
                        </div>


                        <div className="product-action-mob">
                          <div className="d-flex product-action-mob-item">

                            {product?.attributes?.[0]?.stock > 0 && (
                              <p
                                title="Add to Cart"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent link navigation
                                  handleAddToCart(product);
                                }}
                              >
                                <FontAwesomeIcon icon={faCartPlus} />
                              </p>
                            )}
                            <p
                              title={
                                isWishlisted[product.id]
                                  ? "Remove from Wishlist"
                                  : "Add to Wishlist"
                              }
                              onClick={(e) =>
                                handleWishlistToggle(e, product)
                              }
                              className={`wishlist-btn ${isWishlisted[product.id] ? "wishlisted" : ""
                                }`}
                            >
                              <FontAwesomeIcon
                                icon={isWishlisted[product.id] ? solidHeart : outlineHeart}
                                className={isWishlisted[product.id] ? "wishlist-active" : ""}
                              />

                            </p>
                            <Link
                              onClick={() => handleShowQuickView(product.id)}
                            >
                              <p>
                                {" "}
                                <FontAwesomeIcon icon={faEye} />
                              </p>
                            </Link>
                          </div>

                        </div>

                        <p
                          className="product-name"
                          style={{
                            color:
                              colorthemeData?.color_themes?.[0]?.heading_color || "#000",
                          }}
                          title={product.product_name}
                        >
                          {product.product_name.length > 20
                            ? `${product.product_name.substring(0, 30)}...`
                            : product.product_name}
                        </p>

                        {product?.total_stock === 0 && (
                          <p className="out-of-stock-text p-0 m-0">
                            (Out of Stock)
                          </p>
                        )}
                        {/* <p
                          className="product-category"
                          style={{
                            color:
                              colorthemeData?.color_themes?.[0]?.text_color_one,
                          }}
                        >
                          {product.category?.category_name}
                        </p> */}

                        <p
                          className="product-rate p-0 m-0"
                          style={{
                            color:
                              colorthemeData?.color_themes?.[0]
                                ?.primary_color || "#a76d50",
                          }}
                          data-aos="fade-up"
                        >
                          {" "}
                          {product?.product_price !==
                            product?.selling_price && (
                              <span
                                style={{
                                  color:
                                    colorthemeData?.color_themes?.[0]
                                      ?.text_color_one,
                                }}
                                className="discount-price"
                                data-aos="fade-up"
                              >
                                ${product?.product_price}
                              </span>
                            )}{" "}
                          ${product.selling_price}
                        </p>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
              <div className="row justify-content-center">
                <div>
                  <Link to="/shop">
                    <button
                      className="primary-button mt-5"
                      style={{
                        backgroundColor:
                          colorthemeData?.color_themes?.[0]?.primary_color ||
                          "#a76d50",
                      }}
                      data-aos="fade-up"
                    >
                      SEE ALL PRODUCT
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {isOpenQuickViewModal && (
            <QuickView
              isOpenQuickViewModal={isOpenQuickViewModal}
              handlecloseQuikViewMOdal={handlecloseQuikViewMOdal}
              quickViewId={quickViewId}
            />
          )}
        </section>
      )}
    </>
  );
}

export default BestSellerProducts;
